import React from "react";

import makeStyles from '@mui/styles/makeStyles';
import { Skeleton } from '@mui/material';

const useStyles = makeStyles(() => ({
  loading: {
    transform: "none",
  },
  loading2: {
    transform: "none",
    marginTop: "16px",
  },
}));

export const EditSubConstractorLoading = () => {
  const classes = useStyles();

  return (
    <>
      <Skeleton height="268px" width="100%" className={classes.loading} />
      <Skeleton height="588px" width="100%" className={classes.loading2} />
    </>
  );
};
